const rootClass = 'weet-components-avatar';
export { rootClass };
